<template>
  <List :mapState="'cafeteriaDeliveries'" :allDispatch="'cafeteriaDeliveriesAll'"></List>
</template>
<script>
import List from '@/components/modules/base/list.vue'
export default {
  name: 'Lists',
  components: {
    List
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modules/cafeteria/deliveries/list.vue